export const PAYMENT_STATUS = {
  PENDING: "PENDING", // New, or re-requested for this month's trf
  SUCCESS: "SUCCESS",
  CARRIED_OVER: "CARRIED_OVER", // overall accumulated still less than 100
  PAUSED: "PAUSED", // Supplemented by reasons eg. Transaction failed, <100THB
  VOID: "VOID", // Will not be paid due to stuffs like copyright
};

export const downloadAsCsv = (inpData, inpCol, fileName) => {
  const data = [];
  data.push(inpCol.map((col) => col.title).join(","));
  for (const x of inpData) {
    data.push(inpCol.map((col) => x[col.dataIndex]).join(","));
  }

  const text = data.join("\n");
  const blob = new Blob([text], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
